import React from "react";
import { Action } from "@op/opds.opux";
import { Message, useMessage } from "react-message-context";
import { inject } from "mobx-react";

const ActionByCustomerType = ({ RestStore, text, url, className }) => {
  const base = window.location.origin;

  const key = `${url}.${RestStore.customerType.toLowerCase()}`;
  const path = useMessage(key)();

  return (
    <p
      className={`rof-action skip-link-interruption ${
        className ? className : ""
      }`}
    >
      <Action href={`${base}${path}`}>
        <Message id={text} />
      </Action>
    </p>
  );
};

export default inject("RestStore")(ActionByCustomerType);
